import { useState } from 'react';
import Box from "@mui/material/Box"
import MenuBar from "./components/MenuBar"
import Map from "./components/Map"
import PersistentDrawerLeft from "./components/PersistentDrawerLeft"
import DrawerChildren from "./components/DrawerChildren"
import { QueryClient, QueryClientProvider } from 'react-query';
import { SearchProvider } from "./hooks/SearchProvider"

// Create a client
const queryClient = new QueryClient()

function App() {
  const [open, setOpen] = useState<boolean>(false)

  return (
    <QueryClientProvider client={queryClient}>
      <Box sx={{
        gap: 0,
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        overflowY: "hidden"
      }}
      >
        <SearchProvider>
          {/* context for react-query */}
          <MenuBar open={open} opener={setOpen} />
          <PersistentDrawerLeft open={open} opener={setOpen}>
            <DrawerChildren />
          </PersistentDrawerLeft>
          <Map />
        </SearchProvider>
      </Box>
    </QueryClientProvider>
  );
}

export default App;
